import { profilePlaceholder } from 'assets/images';

export default async function getBase64Image(uri: string) {
    let base64;

    if (uri) {
        base64 = await fetch(uri)
            .then((response) => response.blob())
            .then((blob) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                return new Promise((res) => {
                    reader.onloadend = () => {
                        res(reader.result);
                    };
                });
            });
    }

    return base64 || profilePlaceholder;
}
